/* eslint-disable no-use-before-define */

import React from 'react'
import { getId } from '../twd'

export default function({field, form, error, dataName='twd-fields-ratings', label, labelStyle, labelClass, ariaLabel, ...props} = {}) {
    const id = getId()

    let r = props.ratingType
    const ratings =
        r ==='sp' ? spRatings :
        r ==='moodys' ? moodysRatings :
        r ==='fitch' ? fitchRatings :
        spRatings

    let err = form.errors
        && form.errors[field.name]

    return (
    <React.Fragment>
    {label && <label htmlFor={id} style={labelStyle} className={labelClass}>{label}</label>}

    <div className={ 'select-wrapper' + (err || error ? ' has-error': '')}>
    <select
        data-name={dataName}
        className="form-control"
        id={id}
        aria-label={ariaLabel}
        {...field}
        {...(err || error ? {"aria-invalid":true} : {})}
        onChange={(e) =>{
            form.setFieldValue(field.name, e.target.value || '')
        }}
    >{
        ratings.map((a,i) => (<option
            data-name={dataName + '-option'}
            data-value={a}
            key={i}>{a}</option>))
    }</select>
    { err && <label className="field-status has-error">{err}</label> }
    </div>

    </React.Fragment>)
}

export const spRatings = [
    'ALL',
    'AAA',
    'AA+',
    'AA',
    'AA-',
    'A+',
    'A',
    'A-',
    'BBB+',
    'BBB',
    'BBB-',
    'BB+',
    'BB',
    'BB-',
    'B+',
    'B',
    'B-',
    'CCC+',
    'CCC',
    'CCC-',
    'CC',
    'C',
    'CI',
    'SD',
    'D',
    'R',
    'NM',
    'NR',
    'None'
]

export const moodysRatings = [
    'ALL',
    'Aaa',
    'Aa1',
    'Aa2',
    'Aa3',
    'A1',
    'A2',
    'A3',
    'Baa1',
    'Baa2',
    'Baa3',
    'Ba1',
    'Ba2',
    'Ba3',
    'B1',
    'B2',
    'B3',
    'Caa1',
    'Caa2',
    'Caa3',
    'Ca',
    'C',
    'NR/WR',
    'None'
]

export const fitchRatings = [
    'ALL',
    'AAA',
    'AA+',
    'AA',
    'AA-',
    'A+',
    'A',
    'A-',
    'BBB+',
    'BBB',
    'BBB-',
    'BB+',
    'BB',
    'BB-',
    'B+',
    'B',
    'B-',
    'CCC+',
    'CCC',
    'CCC-',
    'CC',
    'C',
    'D',
    'NR',
    'None'
]